import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createRespondentDetailsAPI,
  updateRespondentDetailsAPI,
  deleteRespondentDetailsAPI,
  getRespondentDetailsAPI,
  getRespondentsByCaseIDAPI,
  uploadRespondentDocumentAPI,
  updateRespondentDocumentAPI,
  deleteRespondentDocumentAPI,
  getRespondentDocumentsAPI,
} from "../../../api/respondentDetails_api";

// ============================================================================
// ASYNC THUNKS
// ============================================================================

// NOTE: getRespondentsByCaseIDAction is used after create/update to refresh list
export const getRespondentsByCaseIDAction = createAsyncThunk(
  "respondentDetails/getRespondentsByCase",
  async (caseID, { rejectWithValue }) => {
    const response = await getRespondentsByCaseIDAPI(caseID);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

/**
 * Create Respondent Details
 */
export const createRespondentDetailsAction = createAsyncThunk(
  "respondentDetails/createRespondentDetails",
  async (respondentData, { rejectWithValue }) => {
    const response = await createRespondentDetailsAPI(respondentData);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

/**
 * Update Respondent Details
 */
export const updateRespondentDetailsAction = createAsyncThunk(
  "respondentDetails/updateRespondentDetails",
  async ({ respondentDetailsID, respondentData }, { rejectWithValue }) => {
    const response = await updateRespondentDetailsAPI(
      respondentDetailsID,
      respondentData,
    );
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

/**
 * Delete Respondent Details
 */
export const deleteRespondentDetailsAction = createAsyncThunk(
  "respondentDetails/deleteRespondentDetails",
  async (respondentDetailsID, { rejectWithValue }) => {
    const response = await deleteRespondentDetailsAPI(respondentDetailsID);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return respondentDetailsID;
  },
);

/**
 * Get Respondent Details
 */
export const getRespondentDetailsAction = createAsyncThunk(
  "respondentDetails/getRespondentDetails",
  async (respondentDetailsID, { rejectWithValue }) => {
    const response = await getRespondentDetailsAPI(respondentDetailsID);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

/**
 * Upload Respondent Document
 */
export const uploadRespondentDocumentAction = createAsyncThunk(
  "respondentDetails/uploadDocument",
  async (formData, { rejectWithValue }) => {
    const response = await uploadRespondentDocumentAPI(formData);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

/**
 * Update Respondent Document
 */
export const updateRespondentDocumentAction = createAsyncThunk(
  "respondentDetails/updateDocument",
  async ({ documentID, documentData }, { rejectWithValue }) => {
    const response = await updateRespondentDocumentAPI(
      documentID,
      documentData,
    );
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

/**
 * Delete Respondent Document
 */
export const deleteRespondentDocumentAction = createAsyncThunk(
  "respondentDetails/deleteDocument",
  async (documentID, { rejectWithValue }) => {
    const response = await deleteRespondentDocumentAPI(documentID);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return documentID;
  },
);

/**
 * Get Respondent Documents
 */
export const getRespondentDocumentsAction = createAsyncThunk(
  "respondentDetails/getDocuments",
  async (respondentDetailsID, { rejectWithValue }) => {
    const response = await getRespondentDocumentsAPI(respondentDetailsID);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);
